import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-[#111111] py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-10">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img
              src="https://static.readdy.ai/image/96a0c724104ef419e66a29be1c3abef3/ea33ff0b2a82ce332a59127bdab40a82.png"
              alt="Cornerstone Strategy Logo"
              className="h-12 w-auto object-contain brightness-0 invert"
            />
            <p className="text-white/50 text-xs tracking-wide">
              {t("footer_tagline")}
            </p>
            {/* Social Media Icons */}
            <div className="flex items-center gap-4 mt-1">
              <a
                href="https://www.linkedin.com/company/cornerstone-stragegy-llc"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="LinkedIn"
                className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-[#BF9B5E] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg" />
              </a>
              <a
                href="https://www.facebook.com/CornerstoneStrategy"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="Facebook"
                className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-[#BF9B5E] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-end gap-3">
            <a
              href="https://cornerstone-strategy.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-white/60 text-sm hover:text-[#BF9B5E] transition-colors cursor-pointer"
            >
              {t("footer_website")} &rarr;
            </a>
            <a
              href="https://forms.office.com/r/sZVyHTTrLt"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-white/60 text-sm hover:text-[#BF9B5E] transition-colors cursor-pointer"
            >
              {t("footer_contact")}
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            {t("footer_copyright")}
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://cornerstone-strategy.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("footer_privacy")}
            </a>
            <a
              href="https://cornerstone-strategy.com/terms/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("footer_terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
